var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBaggageAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 10C6.4375 10 6 9.5625 6 9V4C6 3.46875 6.4375 3 7 3H8V10H7ZM18 9C18 9.5625 17.5312 10 17 10H16V3H17C17.5312 3 18 3.46875 18 4V9ZM19.5 12C19.75 12 20 12.25 20 12.5V13.5C20 13.7812 19.75 14 19.5 14H16.9062C16.9375 14.1875 17 14.3438 17 14.5C17 15.3438 16.3125 16 15.5 16C14.6562 16 14 15.3438 14 14.5C14 14.3438 14.0312 14.1875 14.0625 14H7.90625C7.9375 14.1875 8 14.3438 8 14.5C8 15.3438 7.3125 16 6.5 16C5.65625 16 5 15.3438 5 14.5C5 14.3438 5.03125 14.1875 5.0625 14H2.5C2.21875 14 2 13.7812 2 13.5V2H0.5C0.21875 2 0 1.78125 0 1.5V0.5C0 0.25 0.21875 0 0.5 0H3.5C3.75 0 4 0.25 4 0.5V12H19.5ZM15 3V10H9V1.5C9 0.6875 9.65625 0 10.5 0H13.5C14.3125 0 15 0.6875 15 1.5V3ZM13.5 3V1.5H10.5V3H13.5Z",
    fill: "#0C66E1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaggageAlert);
export default __webpack_public_path__ + "static/media/baggageAlert.fa977f94a69d1aead0be0b8a8cac67bf.svg";
export { ForwardRef as ReactComponent };